import Rating from 'semantic-ui-react/dist/es/modules/Rating';
import './Rating.css';

export default Rating;
